import request from "../plugins/axios";

export function add(params) {
  return request({
    url: '/contactMessageBatchSend/store',
    method: 'POST',
    data: params
  })
}

export function getPower(params) {
  return request({
    url: '/contactMessageBatchSend/employeeInfo',
    method: 'GET',
    params
  })
}

export function getSendUserCount(params) {
  return request({
    url: '/contactMessageBatchSend/filterContact',
    method: 'PUT',
    data: params
  })
}

export function contactIndex(params) {
  return request({
    url: '/contactMessageBatchSend/index',
    method: 'GET',
    params
  })
}

export function contactIndexShow(params) {
  return request({
    url: '/contactMessageBatchSend/show',
    method: 'GET',
    params
  })
}

